import { render, staticRenderFns } from "./ContentSection.vue?vue&type=template&id=4f2ac380&"
import script from "./ContentSection.vue?vue&type=script&lang=js&"
export * from "./ContentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports